import { inject } from '@angular/core';
import { HttpInterceptorFn } from '@angular/common/http';
import { catchError, skip, throwError } from 'rxjs';

// Services
import { ToastService } from '../../shared/services/toast.service';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const toastSrv = inject(ToastService);

  const excludedUrls = [
    '/auth/logout',
    '/auth/refresh'
  ];

  return next(req).pipe(
    catchError((error) => {
      let errorMessage;

      // If there's a specific error detail in the response body, map it
      if (error.status === 0) {
        errorMessage = 'Si è verificato un problema. Riprova tra qualche istante.';
      } else if (error.status === 404) {
        errorMessage = 'La risorsa che stai cercando non esiste';
      } else if (error.status === 500) {
        errorMessage = 'Si è verificato un errore interno del server';
      } else if (error.status === 409 && error.error?.title?.includes('File already exists')) {
        // Skip error message for File already exists
        console.debug('File duplicated:', error);
      } else if (error.status === 401 && error.error?.message?.includes('Sessione Scaduta')) {
        // Skip error message for File already exists
        console.debug('Session Expired - Token Refreshed:', error);
      } else if (error.error?.detail) {
        // If 'detail' is available in the response body
        errorMessage = error.error.detail;
      } else if (error.error?.message) {
        // If there's a general message available in the response body
        errorMessage = error.error.message;
      } else if (error.error?.errors && Array.isArray(error.error.errors)) {
        // If there are validation errors, display the first one
        errorMessage = error.error.errors[0];
      }

      // Show the message in the UI
      if (errorMessage && !excludedUrls.some(url => req.url.includes(url))) {
        toastSrv.show({ type: 'error', message: errorMessage });
      }

      // Return the error as observable
      return throwError(() => error);
    })
  );
};
